import * as React from 'react';

import {FormInput, TextField, DropdownField} from "../static/Inputs";
import {Button} from "../static/Elements";
import { withAlert } from 'react-alert'
import ReactLoading from 'react-loading';

import createLogger from "../../utils/createLogger";
const DEBUG = false;
const debug = createLogger(DEBUG, `OpenWebRun.js`);

class OpenWebRun extends React.Component {

  /* ----- lifecycle methods -----*/
  constructor(props) {
    super(props);
    this.state = {
      loadingPost: false,
      method: "geo",
      scan: {
        city: '',
        state: '',
        country: 'usa',
        radius: '',
      }
    }
  }

  /*------ event handlers ------*/
  clearState = () => this.setState({
    loadingPost: false,
    method: "geo",
    scan: {
      city: '',
      state: '',
      country: 'usa',
      radius: ''
    }
  });

  onSubmitNewRun = () => {

    const {user} = this.props;
    let config = {};

    if (this.state.method === "geo"){
      config = {
        method: this.state.method,
        user: user,
        city: this.state.scan.city,
        state: this.state.scan.state,
        country: this.state.scan.country,
        radius: this.state.scan.radius.toString(),
      };
    } else {
      config = {
        method: this.state.method,
        user: user,
        city: '',
        state: '',
        country: '',
        radius: '',
      }
    }

    this.setState({
      ...this.state,
      loadingPost: true
    });

    const {postOpenWebs, closeModal, alert, getOpenWebs} = this.props;
    if (config !== {}){
      postOpenWebs(config).then((data) => {
        getOpenWebs();
        closeModal();
        alert.success(<p className={`alert-message`}>Successfully began scrape</p>);
        this.clearState();
      }).catch((error) => {
        alert.info(<p className={`alert-message`}>Unable to begin scrape ({error})</p>)
      })
    }
  };

  onChangeType = (field) => (input) => {
    console.log(input);
    this.setState({
      ...this.state.scan,
      [field]: input,
    })
  };

  onInputChange = (field) => (input) => {
    this.setState({
      scan: {
        ...this.state.scan,
        [field]: input
      }
    })
  };

  /*----- rendering -----*/
  render () {

    const {
      closeModal,
      canStart,
    } = this.props;

    const {
      onSubmitNewRun,
      onInputChange,
      onChangeType,
    } = this;

    const {
      method,
      scan,
      loadingPost,
    } = this.state;

    const fieldConfigs = {
      method: {
        value: method,
        label: `Method`,
        onChange: onChangeType(`method`),
        classes: `dropdown-margin`,
      },
      scan: {
        city: {
          value: scan.city,
          label: "City",
          onChange: onInputChange(`city`),
          placeholder: "City...",
        },
        state: {
          value: scan.state,
          label: "State",
          onChange: onInputChange(`state`),
          placeholder: "State (e.g. 'MA')...",
        },
        radius: {
          value: scan.radius,
          label: "Radius",
          onChange: onInputChange(`radius`),
          placeholder: "Radius (miles)...",
          type: `number`,
        },
        country: {
          value: scan.country,
          label: "Country",
          onChange: onInputChange(`country`),
        }
      }
    };

    const cannotSubmit = (method === "geo" && (scan.city === '' || method === 'geo' && scan.state === '' || method === 'geo' && scan.radius === ''));

    const geoForm = (
      <div>
        <DropdownField {...fieldConfigs.scan.country}>
          <option className={`dropdown-item`} value={`usa`}>United States</option>
          <option className={`dropdown-item`} value={`ca`}>Canada</option>
        </DropdownField>
        <TextField {...fieldConfigs.scan.city}/>
        <TextField {...fieldConfigs.scan.state}/>
        <TextField {...fieldConfigs.scan.radius}/>
      </div>
    );

    const newcos = (
      <div className={`modal-body-message`}>
        <h5 className={`modal-body-text`}>New Companies Scan</h5>
      </div>
    );

    const clientlist = (
      <div className={`modal-body-message`}>
        <h5 className={`modal-body-text`}>Client List Scan</h5>
      </div>
    );

    const cannotStart = (
      <div className={`modal-body-message create-lead`}>
        <h4 className={`modal-body-text`}>The server cannot run any more scrapes at the moment. Please try again once others have finished.</h4>
         <footer>
          <Button onClick={closeModal}
                  type="theme-light">
            Cancel
          </Button>
        </footer>
      </div>
    );

    const standard = (
      <React.Fragment>
        <FormInput>
          <DropdownField {...fieldConfigs.method}>
            <option className={`dropdown-item`} value={"geo"}>Geographic Scan</option>
            <option className={`dropdown-item`} value={"newcos"}>New Companies</option>
            <option className={`dropdown-item`} value={"clientlist"}>Client List</option>
          </DropdownField>
          {
            (method === "geo") ?
              (geoForm) : (method === "newcos") ?
                (newcos) : (method === "clientlist") ?
                  (clientlist) : null
          }
        </FormInput>

        <footer>
          <Button onClick={closeModal}
                  type="theme-light">
            Cancel
          </Button>
          {
            !canStart ? null : (
              <Button
                      onClick={onSubmitNewRun}
                      disabled={!canStart || cannotSubmit}>
                Run
              </Button>
            )
          }
        </footer>
      </React.Fragment>
    );

    const loading = (
      <div className={`loader-container`}>
        <ReactLoading type={'bubbles'}
                      color={'#6b6c6f'}
                      height={'20%'} width={'20%'}/>
      </div>
    );

    return (
      <div className={`create-lead`}>
        {
          loadingPost ? (loading) : !canStart ? (cannotStart) : (standard)
        }
      </div>
    )
  }
}

export default withAlert(OpenWebRun);


// WEBPACK FOOTER //
// ./src/components/OpenWeb/OpenWebRun.js